import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef } from 'react';
import SimpleBarJS from 'simplebar';
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import 'simplebar/dist/simplebar.min.css';
export const Simplebar = forwardRef((_a, ref) => {
    var { children, className, dataTestId = 'ds-simplebar', style } = _a, otherProps = __rest(_a, ["children", "className", "dataTestId", "style"]);
    const instanceRef = useRef(null);
    const nodeRef = useRef(null);
    useEffect(() => {
        const node = nodeRef.current;
        if (node) {
            instanceRef.current = new SimpleBarJS(node, otherProps);
            if (ref) {
                ref.current =
                    instanceRef.current;
            }
            return () => {
                if (instanceRef.current) {
                    instanceRef.current = null;
                }
            };
        }
        return undefined;
    }, [otherProps, ref]);
    return (_jsxs(Wrapper, { className: className, "data-testid": "ds-simplebar-wrapper", ref: nodeRef, style: style, children: [_jsxs("div", { className: "simplebar-wrapper", children: [_jsx("div", { className: "simplebar-height-auto-observer-wrapper", children: _jsx("div", { className: "simplebar-height-auto-observer" }) }), _jsx("div", { className: "simplebar-mask", children: _jsx("div", { className: "simplebar-offset", children: _jsx("div", { className: "simplebar-content-wrapper", children: _jsx("div", { className: "simplebar-content", "data-testid": dataTestId, children: children }) }) }) }), _jsx("div", { className: "simplebar-placeholder" })] }), _jsx("div", { className: "simplebar-track simplebar-horizontal", children: _jsx("div", { className: "simplebar-scrollbar" }) }), _jsx("div", { className: "simplebar-track simplebar-vertical", children: _jsx("div", { className: "simplebar-scrollbar" }) })] }));
});
const Wrapper = styled(Box) `
  .simplebar-content-wrapper::-webkit-scrollbar {
    display: none;
  }

  .simplebar-scrollbar:before {
    background: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.dove; }};
  }

  .simplebar-scrollbar.simplebar-visible:before {
    opacity: 1;
  }

  .simplebar-content {
    height: inherit;
  }
`;
//# sourceMappingURL=Simplebar.js.map